import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from '../common/DropdownList';
import InfoTooltip from '../common/InfoTooltip';
import EditLineItem from './EditLineItem';
import { formatCurrency } from '../../numberUtils';
function LineItems(_ref) {
  var invoiceId = _ref.invoiceId,
    category = _ref.category,
    _ref$startDate = _ref.startDate,
    startDate = _ref$startDate === void 0 ? '' : _ref$startDate,
    _ref$endDate = _ref.endDate,
    endDate = _ref$endDate === void 0 ? '' : _ref$endDate,
    lineItemsGroupName = _ref.lineItemsGroupName,
    descriptionLabel = _ref.descriptionLabel,
    _ref$hasDuration = _ref.hasDuration,
    hasDuration = _ref$hasDuration === void 0 ? false : _ref$hasDuration,
    rate = _ref.rate,
    handleNewLineItem = _ref.handleNewLineItem,
    handleUpdateLineItem = _ref.handleUpdateLineItem,
    handleDeleteLineItem = _ref.handleDeleteLineItem,
    _ref$handleUploadFile = _ref.handleUploadFile,
    handleUploadFile = _ref$handleUploadFile === void 0 ? function () {
      return null;
    } : _ref$handleUploadFile,
    _ref$csrfToken = _ref.csrfToken,
    csrfToken = _ref$csrfToken === void 0 ? '' : _ref$csrfToken,
    lineItems = _ref.lineItems,
    _ref$totalPay = _ref.totalPay,
    totalPay = _ref$totalPay === void 0 ? 0 : _ref$totalPay,
    _ref$totalTime = _ref.totalTime,
    totalTime = _ref$totalTime === void 0 ? {
      hours: 0,
      minutes: 0
    } : _ref$totalTime,
    status = _ref.status;
  var numOfEdits = lineItems.filter(function (x) {
    return x.feedback;
  }).length;
  return /*#__PURE__*/React.createElement("div", {
    className: "line-items card p-5 border-0"
  }, status === 'edits_requested' && numOfEdits > 0 && /*#__PURE__*/React.createElement("div", {
    className: "request-edits-line-items body-text-2 number-of-edits"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-circle"
  }), "".concat(numOfEdits, " ").concat(category).concat(hasDuration ? ' task' : '').concat(numOfEdits > 1 ? 's' : '', " to edit")), /*#__PURE__*/React.createElement("div", {
    className: "card-body ".concat(numOfEdits > 0 ? 'edits-requested' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(category, "-line-items")
  }, /*#__PURE__*/React.createElement(DropdownList, {
    title: lineItemsGroupName,
    dropdownClass: hasDuration ? "".concat(category, "-hours") : "".concat(category, "s"),
    isSideBySide: true,
    icon: "caret"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header g-row--always"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date"
  }, "Date"), /*#__PURE__*/React.createElement("div", {
    className: "optional-id"
  }, "Optional ID", /*#__PURE__*/React.createElement(InfoTooltip, {
    triggerClassName: "optional-id-tooltip-trigger",
    tooltipId: "optional-id-tooltip",
    tooltipPlacement: "top",
    tooltipText: "This is an optional field you can use to capture project codes/ids, cost centers, or other helpful information."
  })), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, descriptionLabel), hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "hours-and-minutes"
  }, "Hours"), /*#__PURE__*/React.createElement("div", {
    className: "total"
  }, "Total"), !hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "file"
  }), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  })), /*#__PURE__*/React.createElement("div", null, lineItems.map(function (lineItem, index) {
    return /*#__PURE__*/React.createElement(EditLineItem, _extends({}, lineItem, {
      index: index,
      invoiceId: invoiceId,
      key: lineItem.id,
      category: category,
      hasDuration: hasDuration,
      rate: rate,
      startDate: startDate,
      endDate: endDate,
      viewDocumentUrl: lineItem.view_file_url,
      updateLineItem: handleUpdateLineItem,
      deleteLineItem: handleDeleteLineItem,
      uploadFile: handleUploadFile,
      csrfToken: csrfToken,
      status: status
    }));
  })), (status === 'draft' || status === 'edits_requested') && /*#__PURE__*/React.createElement("a", {
    role: "link",
    tabIndex: 0,
    id: "add-line-item",
    className: "g-row--always",
    onClick: function onClick() {
      return handleNewLineItem(category);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-plus me-2"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "uppercase-demibold"
  }, "Add ".concat(category, " ").concat(category !== 'expense' ? 'Hours' : ''))), /*#__PURE__*/React.createElement("div", {
    className: "totals g-row--always"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacer1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "line-item-category-total"
  }, "Total", hasDuration ? category : "".concat(category, "s")), hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "line-item-time"
  }, totalTime.hours, "\xA0h.\xA0", totalTime.minutes, "\xA0min."), /*#__PURE__*/React.createElement("div", {
    className: "line-item-total"
  }, formatCurrency(totalPay)), !hasDuration && /*#__PURE__*/React.createElement("div", {
    className: "spacer2"
  }))))));
}
LineItems.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  handleNewLineItem: PropTypes.func.isRequired,
  handleUpdateLineItem: PropTypes.func.isRequired,
  handleDeleteLineItem: PropTypes.func.isRequired,
  handleUploadFile: PropTypes.func,
  totalTime: PropTypes.shape({
    hours: PropTypes.number,
    minutes: PropTypes.number
  }),
  totalPay: PropTypes.number,
  lineItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  lineItemsGroupName: PropTypes.string.isRequired,
  descriptionLabel: PropTypes.string.isRequired,
  hasDuration: PropTypes.bool,
  rate: PropTypes.number,
  invoiceId: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  csrfToken: PropTypes.string,
  status: PropTypes.string.isRequired
};
export default LineItems;